import { Box, Text } from '@chakra-ui/react'
import Image from "next/legacy/image"
import React from 'react'

const AboutCard = ({ item: { title, img, body } }) => {
    return (
        (<Box w={{ base: "100%", md: "31%", lg: "28%" }} mb={"32px"}>
            <Image
                src={img}
                width={"26px"}
                height={"29px"}
                objectFit={"contain"}
                style={{
                    maxWidth: "100%",
                    height: "auto"
                }} />
            <Text color={"brand.black"} mt={"8px"} fontSize={{ base: "16px", lg: "20px" }} lineHeight={{ base: "27px", lg: "28px" }} fontWeight={"500"}>{title}</Text>
            <Text mt={"16px"} color={"gray.500"} fontSize={"16px"} lineHeight={"27px"} textAlign={{ base: "left" }}>{body}</Text>
        </Box>)
    );
}

export { AboutCard }